import { Modal } from "rsuite";
import WdLoading from "../../assets/WDEdgeLoader.gif";

const CustomLoader = ({ open }: { open: boolean }) => {
	if (!open) {
		return null
	}
	return (
		<div className="flex justify-center h-full">
			<Modal
				className="custom-loader"
				backdrop="static"
				open={open}
				size="sm"
			>
				<Modal.Body>
					<div className="flex item-center justify-center">
						<img
							className="h-full w-[60%]"
							src={WdLoading}
							alt="Loading..."
						/>
					</div>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default CustomLoader;
